import { render, staticRenderFns } from "./ClaimPosting.vue?vue&type=template&id=4f94e1e2&"
import script from "./ClaimPosting.vue?vue&type=script&lang=js&"
export * from "./ClaimPosting.vue?vue&type=script&lang=js&"
import style0 from "./ClaimPosting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClaimPosting.vue"
export default component.exports